<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="!cantGoBack"
    [title]="'Payments Options'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-card>
        <tidy-card-button (action)="goToEditCard()" style="padding-top:0px">
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="'assets/img/credit-card.svg'"
              class="header-size" />
            <tidy-text
              [body]="'Card on File'" />
          </tidy-row>
          <tidy-row>
            @if (card?.last4) {
              <tidy-text
                [helper]="'Ending in'" /><span>&nbsp;</span>
                <tidy-text
                  [helper]="card?.last4" />
              }
              @if (!card?.last4) {
                <tidy-text
                  [helper]="'No card on file'" />
              }
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="goToPaymentSettings()">
            <tidy-row class="vertical-align-center extra-bottom-padding">
              <tidy-image
                [src]="'assets/img/settings.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Payment Settings'" />
            </tidy-row>
            <tidy-row>
              @if (settings?.billing?.charge?.type === 'before_cleaning') {
                <tidy-text
                  [helper]="'Charge in advance (save 10%)'" />
              }
              @if (settings?.billing?.charge?.type !== 'before_cleaning') {
                <tidy-text
                  [helper]="'Charge after jobs are done'" />
              }
            </tidy-row>
          </tidy-card-button>
          @if (clientInfo?.customer_account?.account_type !== 'rental') {
            <tidy-card-button (action)="goToBuyBundle()">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/coupon.svg'"
                  class="header-size" />
                <tidy-text
                  [body]="'Buy a Bundle (save 10%)'" />
              </tidy-row>
            </tidy-card-button>
            <tidy-card-button (action)="goToUseGiftCard()">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/present.svg'"
                  class="header-size" />
                <tidy-text
                  [body]="'Use a Gift Card'" />
              </tidy-row>
            </tidy-card-button>
            <tidy-card-button (action)="goToViewPrices()">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/information-circle-yellow.svg'"
                  class="header-size" />
                <tidy-text
                  [body]="'View Your Current Prices'" />
              </tidy-row>
            </tidy-card-button>
          }
          <tidy-card-button (action)="goToSubscriptions()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/residential.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Subscription'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }
    </tidy-wrapper>
  </ng-template>

  <app-scroll-wrapper [templateContent]="content" />
